const BathroomIcon = ({ viewBox = "0 0 12 14", className = "hayley-h-4 hayley-w-4 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M4.75004 4.91797C3.64497 4.91797 2.58516 5.35696 1.80376 6.13836C1.02236 6.91976 0.583374 7.97957 0.583374 9.08464H8.91671C8.91671 8.53746 8.80893 7.99564 8.59954 7.49012C8.39014 6.9846 8.08323 6.52527 7.69632 6.13836C7.30941 5.75145 6.85008 5.44453 6.34455 5.23514C5.83903 5.02574 5.29722 4.91797 4.75004 4.91797Z"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 4.91667V4.08333C4.75 3.19928 5.10119 2.35143 5.72631 1.72631C6.35143 1.10119 7.19928 0.75 8.08333 0.75V0.75C8.96739 0.75 9.81523 1.10119 10.4404 1.72631C11.0655 2.35143 11.4167 3.19928 11.4167 4.08333V13.25"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.25 10.75V11.5833" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.75 12.418V13.2513" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.25 10.75V11.5833" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default BathroomIcon;
